<template>
  <a-tabs v-model:activeKey="searchForm.status" style="background-color: #fff; padding: 0 12px" @change="updateChange()">
    <a-tab-pane v-for="item in typeList" :key="item.value">
      <template #tab>
        <a-badge
          :count="badge[item.bname]"
          :number-style="{
            height: '15px',
            lineHeight: '15px',
          }"
          :offset="[10, -8]"
          :overflowCount="999"
        >
          <div>{{ item.name }}</div>
        </a-badge>
      </template>
    </a-tab-pane>
  </a-tabs>
  <div class="order">
    <!-- 到期提示 -->
    <div v-if="isExpired" class="expire-banner">
      <div class="expire-banner-content">
        <span class="expire-banner-title">房源已到期</span>
        <span class="expire-banner-info">到期时间：{{ expireDate }}</span>
        <span class="expire-banner-renew">续费路径：手机端 我的->房源管理->购买付费</span>
      </div>
    </div>
    <!-- 搜索 -->
    <div ref="topRef" class="header-bar">
      <div class="bar-lef">
        <div class="lef-group">
          <div class="group-one">
            <a-select v-model:value="searchForm.timeType" placeholder="时间类型" @change="updateChange">
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option :value="3">下单时间</a-select-option>
              <a-select-option :value="1">入住时间</a-select-option>
              <a-select-option :value="2">退房时间</a-select-option>
            </a-select>
          </div>
          <div class="group-one" style="width: 220px">
            <a-range-picker v-model:value="rangePicker" :ranges="ranges" allowClear @change="updateDateChange" />
          </div>
        </div>
        <div class="lef-group">
          <div class="group-one">
            <a-select v-model:value="searchForm.house" :dropdownMatchSelectWidth="false" :maxTagCount="1" allowClear max-tag-count="responsive" mode="tags" placeholder="房型" @change="updateChange">
              <a-select-option value="0">独立房间</a-select-option>
              <a-select-option v-for="item in searchList.room?.list" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.group" :dropdownMatchSelectWidth="false" :maxTagCount="1" allowClear max-tag-count="responsive" mode="tags" placeholder="分组" @change="updateChange">
              <a-select-option v-for="item in searchList.group?.list" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.priceId" allowClear placeholder="净房费" @change="updateChange">
              <a-select-option v-for="item in searchForm.price" :key="item.value" :value="item.value">{{ item.min }}-{{ item.max }} </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.tags" :dropdownMatchSelectWidth="false" :maxTagCount="1" allowClear max-tag-count="responsive" mode="tags" placeholder="标签" @change="updateChange">
              <a-select-option v-for="item in searchList.tag?.list" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.order_type" placeholder="订单盒子" @change="updateChange">
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option :value="1">非订单盒子</a-select-option>
              <a-select-option :value="2">仅订单盒子</a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select
              v-model:value="searchForm.source_ids"
              :dropdownMatchSelectWidth="false"
              :maxTagCount="1"
              allowClear
              max-tag-count="responsive"
              mode="tags"
              placeholder="订单来源"
              @change="updateChange"
            >
              <a-select-option v-for="item in searchList.source?.list" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.type" allowClear placeholder="订单类型" @change="updateChange">
              <a-select-option v-for="item in searchList.orderType?.list" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>

      <div class="bar-rig">
        <div class="rig-one">
          <a-input-search v-model:value="searchForm.keyword" :loading="searchLoading" allowClear placeholder="外部订单号/订单号/房间/姓名" style="width: 250px" @search="onSearch" />
        </div>
        <div class="rig-one">
          <a-input v-model:value="searchForm.hid" allowClear placeholder="房源ID" style="width: 100px" @change="onSearch" />
        </div>
        <div class="rig-one rig-btn">
          <inbox-outlined class="f-20" @click="hendleOpenOrderBox" />
        </div>
        <div class="rig-one">
          <a-dropdown class="rig-btn">
            <ellipsis-outlined class="f-20" />
            <template #overlay>
              <a-menu>
                <a-menu-item key="1" @click="handleReadShow"> 读取订单 </a-menu-item>
                <a-menu-item key="1" @click="handleAddShow"> 新建订单 </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </div>
    </div>

    <!-- table -->
    <div class="table">
      <a-table :columns="columns" :customRow="rowClick" :dataSource="orderList" :loading="searchLoading" :pagination="false" :rowKey="record => record.id" :scroll="{ y: tableHeight }" size="small">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key == 'order'">
            <div>
              {{ record.order_no }}<span class="copy" title="复制" @click.stop="handleCopy(record.order_no)"><copy-outlined /></span>
            </div>
            <div style="display: flex; align-items: center">
              <a-avatar :size="20" :src="record.logo" />
              <span style="margin-left: 2px">
                {{ record.out_trade_no }}<span class="copy" title="复制" @click.stop="handleCopy(record.out_trade_no)"><copy-outlined /></span>
              </span>
            </div>
          </template>
          <template v-if="column.key == 'tenant'">
            <div class="cell">
              <!-- <div class="cell-left">
                <a-avatar :src="record.logo" />
              </div> -->
              <div class="cell-right">
                <div>{{ record.tname }}</div>
                <div v-if="record.tphone">
                  {{ record.tphone }}<span class="copy" title="复制" @click.stop="handleCopy(record.tphone)"><copy-outlined /></span>
                </div>
                <div v-else>-</div>
              </div>
            </div>
          </template>
          <template v-if="column.key == 'room'">
            <div :title="record.name" class="t-h-3">
              {{ record.name }}
            </div>
          </template>
          <template v-if="column.key == 'status'">
            <div v-if="record.status == 4" class="f-c-red">
              {{ record.status_explain ? record.status_explain : record.status_text }}
            </div>
            <div v-else-if="record.status == 3" class="f-c-green">
              {{ record.status_explain ? record.status_explain : record.status_text }}
            </div>
            <div v-else-if="record.status == 5" class="f-c-999">
              {{ record.status_explain ? record.status_explain : record.status_text }}
            </div>
            <div v-else>
              {{ record.status_explain ? record.status_explain : record.status_text }}
            </div>
          </template>
          <template v-if="column.key == 'tag'">
            <div class="table-tag">
              <div v-if="record.order_type == 2" class="tag f-12" style="background-color: #ff4d4f">盒子订单</div>
              <div v-for="item in record.gname" :key="item.gid" :style="{ 'background-color': item.color }" class="tag f-12">
                {{ item.name }}
              </div>
            </div>
          </template>
          <template v-if="column.key == 'checkInDate'">
            <div>
              <div>入{{ record.start_date }}</div>
              <div>离{{ record.end_date }}</div>
              <div>共{{ record.nights }}晚</div>
            </div>
          </template>
          <template v-if="column.key == 'checkInPrice'">
            <div>
              <div class="f-c-999">订单总额：{{ record.order_amount }}</div>
              <div class="f-c-999">佣金：{{ record.royalty }}</div>
              <div>净房费：{{ record.room_price }}</div>
            </div>
          </template>
          <!-- 操作 -->
          <template v-if="column.key == 'oper'">
            <div v-if="record.refund_status == 0">
              <a-button v-if="record.status == 2" :disabled="isExpired" class="btn-primary" style="margin-right: 5px" @click.stop="handleConfirmOrder(record)">确认订单 </a-button>
              <a-button v-if="record.status == 3" :disabled="isExpired" class="btn-primary" style="margin-right: 5px" @click.stop="handleCheckIn(record)">入住 </a-button>
              <a-button v-if="record.status == 3 || record.status == 4" :disabled="isExpired" class="btn-primary" style="margin-right: 5px" @click.stop="handleRoomShow(record)">换房 </a-button>

              <a-button v-if="((record.status == 1 || record.status == 3) && record.type != 3) || record.status == 2" :disabled="isExpired" style="margin-right: 5px" @click.stop="handleCancelOrder(record)"
                >取消订单
              </a-button>
              <a-button v-if="record.status == 4" :disabled="isExpired" style="margin-right: 5px" @click.stop="handleCancelCheckIn(record)">撤销入住 </a-button>
              <a-button v-if="record.status == 4" :disabled="isExpired" style="margin-right: 5px" @click.stop="handleCheckOut(record)">退房 </a-button>
            </div>
            <div v-else-if="record.refund_status == 1 || record.refund_status == 5">
              <a-button :disabled="isExpired" class="btn-primary" style="margin-right: 5px" @click.stop="handleRefund(record, 2)">同意退款 </a-button>
              <a-button :disabled="isExpired" style="margin-right: 5px" @click.stop="handleRefund(record, 1)">拒绝退款 </a-button>
            </div>
          </template>
        </template>
      </a-table>
    </div>
    <MyPagination :pageTotal="pageTotal" @onShowSizeChange="onShowSizeChange" @pageChange="pageChange" />
  </div>

  <!-- 录入订单 -->
  <enter-order :params="enterOrderParams" @refresh="enterOrderRefresh" />

  <!-- 读取订单 -->
  <Reading :params="params" @refresh="refresh" />

  <!-- 换房 -->
  <ChangeRoom v-if="roomShow" :endDate="selOrderItem.end_date" :orderId="selOrderItem.id" :startDate="selOrderItem.start_date" @closeChangeRoom="roomShow = false" @confirmChangeRoom="updateChange" />

  <!-- 订单详情 -->
  <order-details v-model:visible="detShow" :orderId="orderId" @refreshOrderDetails="refresh" />

  <order-box ref="orderBoxRef" :boxShow="orderBoxShow" @orderBoxClose="orderBoxClose" />
</template>

<script>
import { createVNode, onMounted, reactive, toRefs, watch } from 'vue';
import { CopyOutlined, EllipsisOutlined, ExclamationCircleOutlined, InboxOutlined } from '@ant-design/icons-vue';
import { agreefund, cancelOrder, changeRoom, checkOutRomm, confirmOrder, getCompanyConfig, getOrderList, getSearchList, getStockRoomList, orderConfirmIn, orderRevokeCheckin, refuseFund } from '@/api/api';
import { message, Modal } from 'ant-design-vue';
import dayjs from 'dayjs';
import useUtils from '@/hooks/useUtils.js';
import Reading from '@/components/pms/landlord/Reading/Reading.vue';
import orderBox from '@/components/pms/landlord/orderBox/orderBox.vue';
import OrderDetails from '@/components/pms/landlord/OrderDetails/OrderDetails.vue';
// import AddOrder from "@/components/pms/landlord/AddOrder/AddOrder.vue";
import useClipboard from 'vue-clipboard3';
import ChangeRoom from '@/components/pms/landlord/ChangeRoom/ChangeRoom.vue';
import EnterOrder from '@/components/pms/landlord/EnterOrder/EnterOrder.vue';
import store from '@/store/pms/landlord/index';

export default {
  components: {
    InboxOutlined,
    EnterOrder,
    Reading,
    orderBox,
    OrderDetails,
    // AddOrder,
    EllipsisOutlined,
    CopyOutlined,
    ChangeRoom,
  },
  setup() {
    // 父子组件 通讯
    const messages = reactive({
      params: {
        title: '读取订单',
        sync_ids: '2',
        show: false,
      },

      // 激活渠道盒子
      handleReadShow() {
        opers.detShow = false;
        messages.params.show = true;
      },

      // 子组件回调
      refresh() {
        search.getOrderList();
      },

      // 订单盒子
      orderBoxShow: false,
      orderBoxRef: '',
      // show
      hendleOpenOrderBox() {
        opers.detShow = false;
        messages.orderBoxShow = true;
      },
      // 盒子回调
      // 关闭
      orderBoxClose() {
        messages.orderBoxShow = false;
      },

      // 录入订单
      enterOrderParams: {
        show: false,
      },
      enterOrderRefresh(type) {
        if (type == 'init') {
          search.getOrderList();
          messages.enterOrderParams.show = false;
        }
      },
    });

    const { countTable } = useUtils();
    // 表格---列
    const columns = [
      {
        title: '订单ID',
        key: 'order',
        width: 200,
      },
      {
        title: '房客',
        key: 'tenant',
        width: 150,
      },
      {
        title: '房间',
        dataIndex: 'name',
        key: 'room',
        width: 200,
      },
      {
        title: '状态',
        key: 'status',
        dataIndex: 'status_text',
        width: 100,
      },
      {
        title: '入离',
        key: 'checkInDate',
        width: 130,
      },
      {
        title: '房费',
        key: 'checkInPrice',
        width: 150,
      },
      {
        title: '标签',
        key: 'tag',
        width: 200,
      },
      {
        title: '下单时间',
        dataIndex: 'create_time',
        key: 'create_time',
        width: 200,
      },
      {
        title: '操作',
        key: 'oper',
        width: 250,
      },
    ];
    // 搜索
    const search = reactive({
      searchLoading: false,
      topRef: '',
      tableHeight: '',
      show: true,
      searchList: [],
      orderList: [],
      badge: [], //徽标数
      isExpired: false,
      expireDate: '',
      rangePicker: '',
      searchForm: {
        status: 0,
        type: [],
        dates: [],
        room: [],
        house: [],
        group: [],
        tags: [],
        keyword: '',
        hid: '',
        priceId: null,
        timeType: [],
        order_type: [],
        source_ids: [],

        price: [
          {
            value: 1,
            min: 0,
            max: 150,
          },
          {
            value: 2,
            min: 150,
            max: 200,
          },
          {
            value: 3,
            min: 200,
            max: 300,
          },
          {
            value: 4,
            min: 300,
            max: 400,
          },
          {
            value: 5,
            min: 400,
            max: 600,
          },
          {
            value: 6,
            min: 600,
            max: 9999,
          },
        ],
        start: 0,
        limit: 20,
      },
      // 订单类型
      typeList: [
        { name: '全部', value: 0 },
        { name: '今日待入住', value: 9, bname: 'in_time' },
        { name: '今日待退房', value: 10, bname: 'out_time' },
        { name: '待支付', value: 1, bname: 'stay_pay' },
        { name: '待确认', value: 2, bname: 'stay_confirm' },
        { name: '待入住', value: 3, bname: 'stay_live' },
        { name: '入住中', value: 4, bname: 'checkin' },
        { name: '售后', value: 8, bname: 'sale_count' },
        { name: '已取消', value: 5 },
        { name: '已完成', value: 6 },
        // { name: "盒子订单", value: 6 },
      ],
      // 重置搜索
      handleReset() {
        search.searchForm.dates = [];
        search.searchForm.room = [];
        search.searchForm.house = [];
        search.searchForm.group = [];
        search.searchForm.tags = [];
        search.searchForm.keyword = '';
        search.searchForm.hid = '';
        search.searchForm.timeType = [];
        search.searchForm.order_type = [];
        search.searchForm.source_ids = [];
        search.searchForm.priceId = null;
        search.rangePicker = '';
        search.updateChange();
      },
      ranges: {
        昨天: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')],
        今天: [dayjs(), dayjs()],
        明天: [dayjs().add(1, 'day'), dayjs().add(1, 'day')],
        最近7天: [dayjs().subtract(7, 'day'), dayjs()],
        最近30天: [dayjs().subtract(30, 'day'), dayjs()],
        上月: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
        本月: [dayjs().startOf('month'), dayjs().endOf('month')],

        上季度: [dayjs().startOf('month').add(-1, 'year').month(9), dayjs().endOf('month').add(-1, 'year').month(11)],
        本季度: [dayjs().startOf('month').month(0), dayjs().endOf('month').month(2)],
      },
      // 复制订单号
      handleCopy(value) {
        try {
          useClipboard().toClipboard(value);
          message.success('复制成功');
        } catch (error) {
          message.error('复制失败');
        }
      },
      // 搜索栏
      onSearch() {
        search.getOrderList();
      },
      // 更新查询
      updateChange() {
        search.getOrderList();
      },
      // date
      updateDateChange(date, dateString) {
        search.searchForm.dates = dateString;
        if (search.searchForm.timeType.length == 0) {
          search.searchForm.timeType = 0;
        }
        search.getOrderList();
      },
      // 订单列表
      getOrderList() {
        opers.detShow = false;
        opers.orderId = '';
        // 订单列表
        let minp = '';
        let maxp = '';
        if (search.searchForm.priceId) {
          search.searchForm.price.some(item => {
            if (item.value == search.searchForm.priceId) {
              minp = item.min;
              maxp = item.max;
              return true;
            }
          });
        }
        search.searchLoading = true;
        getOrderList({
          start: search.searchForm.start,
          limit: search.searchForm.limit,
          table: search.searchForm.status,
          type: search.searchForm.type,
          search: search.searchForm.keyword,
          hid: search.searchForm.hid,
          order_type: search.searchForm.order_type,
          source_ids: search.searchForm.source_ids.join(','),
          min_price: minp,
          max_price: maxp,
          rid_arr: search.searchForm.house.join(','),
          hid_arr: search.searchForm.room.join(','),
          tag_id_arr: search.searchForm.tags.join(','),
          gid_arr: search.searchForm.group.join(','),
          start_time: search.searchForm.dates.length ? search.searchForm.dates[0] : '',
          end_time: search.searchForm.dates.length ? search.searchForm.dates[1] : '',
          time_table: search.searchForm.timeType,
        })
          .then(res => {
            search.orderList = res.data.list;
            search.badge = res.data.statistics;
            pagination.pageTotal = res.data.count;
            // switch (search.searchForm.status) {
            //   case 1:
            //     pagination.pageTotal = res.data.count.stay_pay;
            //     break;
            //   case 2:
            //     pagination.pageTotal = res.data.count.stay_confirm;
            //     break;
            //   case 3:
            //     pagination.pageTotal = res.data.count.stay_live;
            //     break;
            //   case 4:
            //     pagination.pageTotal = res.data.count.checkin;
            //     break;
            //   case 5:
            //     pagination.pageTotal = res.data.count.cancel;
            //     break;
            //   case 6:
            //     pagination.pageTotal = res.data.count.finish;
            //     break;
            //   case 7:
            //     pagination.pageTotal = res.data.count.box_count;
            //     break;
            //   case 8:
            //     pagination.pageTotal = res.data.count.sale_count;
            //     break;
            //   default:
            //     pagination.pageTotal = res.data.count.total;
            //     break;
            // }
          })
          .finally(() => {
            search.searchLoading = false;
          });
      },
      // 检查公司配置（房源到期时间）
      checkCompanyConfig() {
        getCompanyConfig()
          .then(res => {
            const data = res.data || {};
            // data.expire = true; // TODO: 临时测试，记得删除
            if (data.expire) {
              search.isExpired = true;
              search.expireDate = data.house_expire_time ? dayjs(data.house_expire_time * 1000).format('YYYY-MM-DD') : '';
            } else {
              search.isExpired = false;
              search.expireDate = '';
            }
            params.getParams();
            search.getOrderList();
          })
          .catch(() => {
            search.isExpired = false;
            search.expireDate = '';
            params.getParams();
            search.getOrderList();
          });
      },
    });

    // 搜索参数列表
    const params = reactive({
      getParams() {
        // 获取查询参数列表
        getSearchList().then(res => {
          search.searchList = res.data;
        });
      },
    });

    // 订单操作
    const opers = reactive({
      orderId: '',
      detShow: false,
      // table 点击行
      rowClick(record) {
        return {
          onClick: () => {
            if (search.isExpired) {
              message.warning('房源已到期，到期时间：' + search.expireDate + '，续费路径：手机端 我的->房源管理->购买付费');
              return;
            }
            opers.orderId = record.id;
            opers.detShow = true;
            // details.getOrderDetail(record.id);
          },
          style:
            record.id == opers.orderId
              ? {
                  'background-color': '#e6f7ff',
                }
              : {},
        };
      },
      channelInfo: '',
      addFormRef: '',
      addShow: false,
      roomShow: false,
      stockRoomList: [],
      selRoomItem: '',
      selOrderItem: '',
      addForm: {
        roomName: '',
        remark: '',
        dateTime: [dayjs().format('YYYY-MM-DD'), dayjs().add(1, 'day').format('YYYY-MM-DD')],
        origin: '',
        housePrice: '',
        commission: '',
        deposit: '',
        payee: '',
        orderNum: '',
        users: [
          {
            name: '',
            phone: '',
            idcard: '',
          },
        ],
      },

      addTenantTitle: '添加房客',
      tenantShow: false,
      tenantRef: '',
      tenantType: '',
      tenantItem: '',
      tenantForm: {
        name: '',
        phone: '',
        idcard: '',
      },

      // 退房
      handleCheckOut(item) {
        Modal.confirm({
          title: '是否退房?',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            checkOutRomm({
              order_id: item.id,
            }).then(res => {
              message.success(res.msg);
              search.getOrderList();
            });
          },
        });
      },

      // 换房 --- 确定
      handleConfirmChangeRoom() {
        if (!opers.selRoomItem?.id) {
          message.error('请选择房间');
          return;
        }
        changeRoom({
          order_id: opers.selOrderItem.id,
          hid: opers.selRoomItem.id,
        }).then(res => {
          message.success(res.msg);
          search.getOrderList();
          opers.roomShow = false;
          opers.selRoomItem = '';
          opers.selOrderItem = '';
        });
      },
      // 选中房间 --- 换房
      handleSelRoom(item) {
        opers.selRoomItem = item;
      },
      // 禁用日期
      disabledDate(val) {
        return val && val < dayjs().subtract(1, 'day');
      },
      // 选中入离日期
      addDateChange() {
        opers.getStockRoomList();
      },
      // 过滤起器
      filterOption(value, option) {
        return option.children[0].children.includes(value);
      },

      // 获取可定房间列表
      getStockRoomList() {
        getStockRoomList({
          start: 0,
          limit: 999,
          table: 1,
          start_time: opers.addForm.dateTime[0],
          end_time: opers.addForm.dateTime[1],
        }).then(res => {
          opers.stockRoomList = res.data;
        });
      },

      // 退款
      handleRefund(params, s) {
        let title;
        if (s == 1) {
          title = '确定拒绝退款？';
        } else {
          title = '确定同意退款？';
        }
        Modal.confirm({
          title: title,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            if (s == 1) {
              refuseFund({
                order_id: params.id,
              }).then(res => {
                message.success(res.msg);
                search.getOrderList();
              });
            } else {
              agreefund({
                order_id: params.id,
              }).then(res => {
                message.success(res.msg);
                search.getOrderList();
              });
            }
          },
        });
      },

      // 确认订单(接单)
      handleConfirmOrder(params) {
        Modal.confirm({
          title: '确定要接单吗?',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            confirmOrder({
              order_id: params.id,
            }).then(res => {
              message.success(res.msg);
              search.getOrderList();
            });
          },
        });
      },
      // 取消订单
      handleCancelOrder(params) {
        Modal.confirm({
          title: '确定要取消订单吗?',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            cancelOrder({
              order_id: params.id,
            }).then(res => {
              message.success(res.msg);
              search.getOrderList();
            });
          },
        });
      },
      // 确定入住
      handleCheckIn(item) {
        Modal.confirm({
          title: '确定改为入住状态？',
          content: '请确认房客已经实际入住',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            orderConfirmIn({ order_id: item.id }).then(res => {
              message.success(res.msg);
              search.getOrderList();
            });
          },
        });
      },
      // 撤销入住
      handleCancelCheckIn(item) {
        Modal.confirm({
          title: '确定撤销入住吗？',
          content: '订单将变为待入住状态',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            orderRevokeCheckin({ order_id: item.id }).then(res => {
              message.success(res.msg);
              search.getOrderList();
            });
          },
        });
      },

      // 换房 dialog
      handleRoomShow(item) {
        opers.roomShow = true;
        opers.selOrderItem = item;
        // getStockRoomList({
        //   start: 0,
        //   limit: 999,
        //   table: 1,
        //   start_time: item.start_date,
        //   end_time: item.end_date,
        // }).then((res) => {
        //   opers.stockRoomList = res.data;
        // });
      },

      // 新建订单 dialog
      handleAddShow() {
        messages.enterOrderParams.show = true;
        messages.enterOrderParams.date = [];
        // opers.addShow = true;
        // opers.getStockRoomList();
      },

      // 拒绝退款
      handleRefuseFund(item) {
        refuseFund({
          order_id: item.id,
        }).then(res => {
          message.success(res.msg);
          search.getOrderList();
        });
      },

      // 同意退款
      handleAgreeFund(item) {
        agreefund({
          order_id: item.id,
        }).then(res => {
          search.getOrderList();
          message.success(res.msg);
        });
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        search.getOrderList();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        search.getOrderList();
      },
    });

    watch(
      () => store.state.ContentHeight,
      () => {
        search.tableHeight = countTable(search.topRef) - 70;
      }
    );

    onMounted(() => {
      search.checkCompanyConfig();
      search.tableHeight = countTable(search.topRef) - 70;
    });
    const { imgCut } = useUtils();
    let logo = imgCut(JSON.parse(sessionStorage.getItem('companyInfo') || '{}').logo || '', 's');
    return {
      // ...toRefs(details),
      ...toRefs(messages),
      ...toRefs(pagination),
      ...toRefs(opers),
      ...toRefs(search),
      imgCut,
      logo,
      columns,
    };
  },
};
</script>

<style lang="scss" scoped>
.ant-tabs > .ant-tabs-nav {
  margin: 0;
}

.order {
  padding: 0px 10px 0 10px;
}

.rig-btn {
  width: 50px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: #0094ff;
  }
}

.cell {
  display: flex;
  align-items: center;

  .cell-left {
    margin-right: 4px;
  }

  .cell-right {
    width: 180px;

    & div:first-child {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}

// .ant-tabs > .ant-tabs-nav {
//   margin: 0 !important;
// }

// 订单详情
.detail {
  .det-head {
    .detail-info {
      padding-top: 60px;

      .head-house {
        border-bottom: 1px solid #f3f3f3;
        padding-bottom: 6px;
        margin-bottom: 10px;

        .house-top {
          display: flex;
          align-items: center;
          margin-bottom: 6px;

          .top-img {
            margin-right: 10px;
          }

          .top-text {
            .text-name {
            }

            .text-type {
              color: #ccc;
              font-size: 12px;
            }
          }
        }

        .house-bom {
          font-size: 12px;
          color: #999;
        }
      }

      .head-tag {
        display: flex;
        flex-wrap: wrap;
        border-bottom: 1px solid #f3f3f3;
        padding-bottom: 10px;
        margin-bottom: 10px;

        .tag-btn {
          padding: 3px 10px;
          margin: 5px;
          border-radius: 3px;
          color: #fff;
          background-color: #0094ff;
        }

        .tag-btn-g {
          padding: 3px 10px;
          margin: 5px;
          border-radius: 3px;
          color: #999;
          background-color: #ebebeb;
        }
      }

      .head-info {
        border-bottom: 1px solid #f3f3f3;
        padding-bottom: 10px;
        margin-bottom: 10px;

        .info-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 6px;

          .title-left {
            font-size: 14px;
            font-weight: bold;
          }

          .title-right {
            color: #0094ff;
          }
        }

        .info-cont {
          .cont-cell {
            display: flex;

            .cell-title {
              flex: 2;
              color: #999;
            }

            .cell-data {
              flex: 8;

              .det {
                color: #0094ff;
              }

              .copy {
                font-size: 12px;
                cursor: pointer;
                padding: 2px 5px;
                border: 1px solid #f3f3f3;
                border-radius: 4px;
              }
            }
          }
        }
      }

      .head-info:last-child {
        margin-bottom: 0;
        border-bottom: none;
        padding-bottom: 0;
      }
    }

    .detail-cost {
      padding-top: 60px;
    }

    .detail-tenant {
      padding-top: 60px;

      .tenant-cell {
        border-bottom: 1px solid #f3f3f3;
        padding-bottom: 6px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .cell-left {
          .cell-name {
            font-weight: bold;
            font-size: 16px;
          }

          .cell-data {
            display: flex;

            .data-title {
              // flex: 4;
              width: 50px;
              color: #999;
            }

            .data-info {
              // flex: 6;
            }
          }
        }

        .cell-right {
          cursor: pointer;

          .right-edit {
            color: #0094ff;
          }

          .right-del {
            color: #dd0054;
          }
        }
      }
    }
  }
}

// 添加 记账
.addAccount {
}

.table-tag {
  display: flex;
  flex-wrap: wrap;

  .tag {
    color: #fff;
    margin: 2px;
    padding: 2px 3px;
    border-radius: 4px;
  }
}

.copy {
  font-size: 10px;
  cursor: pointer;
  // padding: 1px 2px;
  // border: 1px solid #f3f3f3;
  // border-radius: 4px;
  margin-left: 6px;
  // display: inline-block;
  // transform: scale(0.9);
  color: #afafaf;
}

.expire-banner {
  background-color: #fff1f0;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 12px;

  .expire-banner-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;

    .expire-banner-title {
      color: #cf1322;
      font-size: 16px;
      font-weight: bold;
    }

    .expire-banner-info {
      color: #cf1322;
      font-size: 14px;
    }

    .expire-banner-renew {
      color: #595959;
      font-size: 14px;
    }
  }
}
</style>
